module.exports = __webpack_public_path__ + "img/proyecto_12.3f9c414f.png";